import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  Box,
  Grid,
  IconButton
} from '@material-ui/core';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { postAddSubscriptionUser } from '../../../serviceAPI/postAddSubscriptionUser';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginTop: 20,
    marginBottom: 20
  },
  pos: {
    marginBottom: 12,
  },
  buttonWhatsApp: {
    backgroundColor: "#00e676",
  },
  whatsAppIcon: {
    color: "#FFF"

  }

});

export default function SimpleCard(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const vaga = props.vaga

  const [nomeEmpresa, setNomeEmpresa] = React.useState("");

  let vagaAction = '';
  if (vaga.userSubscription) {
    vagaAction = <Button variant="contained" disabled>Candidatou-se</Button>
  } else {
    vagaAction = <Button onClick={() => handleToSubscribe()} variant="contained" color="primary">Candidatar-se</Button>
  }

  function handleToSubscribe() {
    console.log(vaga.id);
    postAddSubscriptionUser(vaga.id, dispatch);
  }

  function salaryFormatter(val) { return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  let salarysFormataded = `${salaryFormatter(vaga.salary_min || 0)} até ${salaryFormatter(vaga.salary_max || 0)}`

  function shareOpportunity(id) {
    const url = `https://wa.me/?text=https://capp.ml/detalhes-vaga-externo?id=${id}`
    window.open(url, '_blank')
  }

  React.useEffect(() => {
    if (vaga.confidential) {
      setNomeEmpresa("Nome da empresa confidencial");
    } else if (vaga.company) {
      setNomeEmpresa(vaga.company.person.name)
    }
  }, [vaga])

  return (

    <Card className={classes.root}>
      <CardContent>
        <Typography variant="h4" component="h2">
          {vaga.title || ""}
          {vaga.userSubscription &&
            <h3 style={{ fontSize: 12, color: "#999" }}>
              {vaga.userSubscription && `*Você ja se canditadou a essa vaga`}
            </h3>
          }
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {nomeEmpresa}
        </Typography>

        <strong>Localização</strong><br />{vaga.city ? vaga.city.name : ""} - {vaga.city ? vaga.city.state.uf : ""}<br /><br />
        <strong>Descrição</strong><br />{vaga.description || ""}<br /><br />
        <strong>Habilidades requeridas</strong><br />{vaga.requirement || ""}<br /><br />
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <strong>Salário</strong> <br />{salarysFormataded}<br /><br />
            </Grid>
            <Grid item md={3}>
              <strong>Tipo de Contrato</strong><br />{vaga.type || ""}<br /><br />
            </Grid>
            <Grid item md={3}>
              <strong>Benefícios</strong> <br />{vaga.benefit || ""}<br /><br />
            </Grid>
            <Grid item md={3}>
              <strong>Vagas</strong> <br />{vaga.quantity || ""}
            </Grid>
          </Grid>
        </div>
      </CardContent>
      <CardActions>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="flex-end"
        >
          <Grid item>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Typography color="textSecondary">
                Compartilhar:
            </Typography>
              <IconButton
                className={classes.buttonWhatsApp}
                aria-label="whatsapp"
                component="span"
                onClick={() => shareOpportunity(vaga.id)}
              >
                <WhatsAppIcon className={classes.whatsAppIcon} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item>
            {vagaAction}
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}
